import React from 'react';
import Icon from '../../../icon';
import PropTypes from 'prop-types';

const ArcherTooltip = (props) => {

    return (
        <div className={`archer-tooltip-icon--wrapper`} tabIndex={0}>
            <Icon icon={'information'} additionalClasses="archer-result__item--icon archer-result__item--icon-white"></Icon>
            <Icon icon={'information-black'} additionalClasses="archer-result__item--icon archer-result__item--icon-black"></Icon>
            <div className={'archer-tooltip'}>

                <div className={`archer-tooltip__content`}>
                    <div dangerouslySetInnerHTML={{ __html: props.content }}></div>
                    <div className="archer-tooltip__arrow"></div>
                </div>
            </div>
        </div>
    );
};

ArcherTooltip.propTypes = {
    content: PropTypes.string
};

export default ArcherTooltip;
